import { resolveSemanticColor } from '@/theme/semanticTokens';
import { r, s, typographyTokens } from '@/theme/tokens';
import { tableV2FooterHeight } from './TableV2Constants';
import type { SxProps, Theme } from '@/ui/primitives';

export const tableV2FooterCompactPageSizeSelectMinWidth = '88px';
export const tableV2FooterDefaultPageSizeSelectMinWidth = `calc(${s('3xl')} * 3)`;

export const tableV2FooterRootSx = (contentInsetX: string): SxProps<Theme> => ({
  alignItems: 'center',
  backgroundColor: (theme) => resolveSemanticColor(theme, 'surface'),
  borderTop: (theme) => `1px solid ${theme.app.colors.border}`,
  display: 'flex',
  height: tableV2FooterHeight,
  justifyContent: 'space-between',
  minWidth: 0,
  pl: {
    xs: s('md'),
    sm: contentInsetX,
  },
});

export const tableV2FooterLabelSx = (labelFontSizePx?: number): SxProps<Theme> => ({
  flex: '1 1 auto',
  fontSize: labelFontSizePx
    ? (theme) => theme.typography.pxToRem(labelFontSizePx)
    : (theme) => theme.typography.pxToRem(13),
  fontWeight: typographyTokens.body.fontWeight,
  minWidth: 0,
  overflow: 'hidden',
  pl: s('none'),
  pr: s('md'),
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

export const tableV2FooterControlsSx = (contentInsetX: string): SxProps<Theme> => ({
  alignItems: 'center',
  display: 'flex',
  flex: '0 0 auto',
  gap: {
    xs: s('xs'),
    sm: s('sm'),
  },
  pr: {
    xs: s('md'),
    sm: contentInsetX,
  },
});

export const tableV2FooterPageTokensSx: SxProps<Theme> = {
  alignItems: 'center',
  display: {
    xs: 'none',
    sm: 'inline-flex',
  },
  gap: s('xs'),
};

export const tableV2FooterSelectRadius = r('sm');
